import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom'
import { FormattedMessage } from 'react-intl';

import SettingsIcon from '@mui/icons-material/Settings';
import MoreIcon from '@mui/icons-material/MoreVert';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import LogoutIcon from '../icons/LogoutIcon'
import RequestIcon from '../icons/RequestIcon'
import ApprovalIcon from '../icons/ApprovalIcon'
import FileLockIcon from '../icons/FileLockIcon'
import FileUnlockIcon from '../icons/FileUnlockIcon'
import QRIcon from '../icons/QRIcon'

import { logout, clearSolList, clearCloak, CloakKey, ChangePwd, RevokeCert, Processing } from 'cloak-file-sdk-web';

import { styled } from '@mui/system';
import { modalStyles } from '../../styles/styles'
import { Box } from '@mui/material';

import withNavigation from '../WithNavigation';

const modalStyle = modalStyles.cloakModal

const CenteredLinkMenuItemDiv = styled(Box)(({ theme }) => ({
	justifyContent: 'center',
	backgroundColor: 'transparent',
	color: 'rgba(0, 0, 0, 0.87)'
}));

const IconButtonRoot = styled(IconButton)(({ theme }) => ({
	textAlign: 'center',
	flex: '0 0 auto',
	marginTop: '0px',
	padding: 0,
	backgroundColor: 'transparent',
	overflow: 'visible', // Explicitly set the default value to solve a bug on IE 11.
	color: '#555555',
	transition: 'none',
	'&:hover': {
		backgroundColor: 'transparent',
		'@media (hover: none)': {
			backgroundColor: 'transparent',
		},
		'&.Mui-disabled': {
			backgroundColor: 'transparent',
		},
	},
	'&.Mui-disabled': {
		color: '#dbdbdb',
	},
}));

const ColorSecondaryBadge = styled('span')(({ theme }) => ({
	backgroundColor: '#ffd633',
	color: '#3e3e3e'
}));

const HideBadge = styled('span')(({ theme }) => ({
	transform: 'scale(0) translate(50%, -50%)',
	transformOrigin: '100% 0%'
}));

const ShowBadge = styled('span')(({ theme }) => ({
}));

const ModifiedBadge = styled('span')(({ theme }) => ({
	transform: 'scale(1) translate(-100%, 0%)',
	transformOrigin: '100% 0%'
}));


class PrimaryMenuBar extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			login: false,
			signUp: false,
			cloakQR: false,
			/*anchorEl: null,*/
			mobileMoreAnchorEl: null
		}
		this.onLogout = this.onLogout.bind(this);
	}

	onLogout() {
		//this.setState({ login: false, signUp: false, cloakQR: false })
		this.props.dispatch(clearCloak())
		this.props.dispatch(clearSolList())
		this.props.dispatch(logout())
		//window.location.reload()
		this.setState({ mobileMoreAnchorEl: null });

		this.props.navigate('/cloak/login');
	}

	async selected(id) {
		console.log("In selectedId " + id)
		if (id === 'signUp') {
			console.log("In selectedId bf signUp %o", this.state.signUp)
			this.setState({ signUp: true, login: false, cloakQR: false })
			console.log("In selectedId af signUp %o", this.state.signUp)
		} else if (id === 'login') {
			console.log("In selectedId bf login %o", this.state.login)
			this.setState({ signUp: false, login: true, cloakQR: false })
			console.log("In selectedId af login %o", this.state.login)
		} else if (id === 'cloakQR') {
			console.log("In selectedId bf cloakQR %o", this.state.cloakQR)
			this.setState({ signUp: false, login: false, cloakQR: true })
			console.log("In selectedId af cloakQR %o", this.state.cloakQR)
		}

	}

	componentDidMount() {
	}

	async handleMobileMenuOpen(event) {
		this.setState({ mobileMoreAnchorEl: event.currentTarget });
	};

	async handleMobileMenuClose() {
		this.setState({ mobileMoreAnchorEl: null });
	};

	render() {

		const { token, pendingApprovals, pendingRequests, authInProgress } = this.props;
		const { mobileMoreAnchorEl } = this.state;
		const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);


		const renderMobileMenu = (
			<Menu
				anchorEl={mobileMoreAnchorEl}
				anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
				transformOrigin={{ vertical: 'top', horizontal: 'right' }}
				open={isMobileMenuOpen}
				onClose={() => this.handleMobileMenuClose()}
			>
				<MenuItem onClick={() => this.handleMobileMenuClose()}>
					<NavLink to="/cloak/qr">
						<CenteredLinkMenuItemDiv>
							<IconButtonRoot color="inherit" size="large">
								<QRIcon />
							</IconButtonRoot>
							&nbsp;<small><FormattedMessage id="cloak.cloakQR" /></small>
						</CenteredLinkMenuItemDiv>
					</NavLink>
				</MenuItem>
				<MenuItem onClick={() => this.handleMobileMenuClose()}>
					<NavLink to="/cloak/cloak">
						<CenteredLinkMenuItemDiv>
							<IconButtonRoot color="inherit" size="large">
								<FileLockIcon />
							</IconButtonRoot>
							&nbsp;<small><FormattedMessage id="cloak.cloak" /></small>
						</CenteredLinkMenuItemDiv>
					</NavLink>
				</MenuItem>
				<MenuItem onClick={() => this.handleMobileMenuClose()}>
					<NavLink to="/cloak/uncloak">
						<CenteredLinkMenuItemDiv>
							<IconButtonRoot color="inherit" size="large">
								<FileUnlockIcon />
							</IconButtonRoot>
							&nbsp;<small><FormattedMessage id="cloak.uncloak" /></small>
						</CenteredLinkMenuItemDiv>
					</NavLink>
				</MenuItem>
				<MenuItem onClick={() => this.handleMobileMenuClose()}>
					<NavLink to="/cloak/requests">
						<CenteredLinkMenuItemDiv>
							<IconButtonRoot color="inherit" size="large">
								<Badge badgeContent={pendingRequests} color="secondary" classes={{
									colorSecondary: ColorSecondaryBadge,
									badge: (pendingRequests === 0 ? HideBadge : ModifiedBadge)
								}}>
									<RequestIcon />
								</Badge>
							</IconButtonRoot>
							&nbsp;<small><FormattedMessage id="solicitation.request" /></small>
						</CenteredLinkMenuItemDiv>
					</NavLink>
				</MenuItem>
				<MenuItem onClick={() => this.handleMobileMenuClose()}>
					<NavLink to="/cloak/approvals">
						<CenteredLinkMenuItemDiv>
							<IconButtonRoot color="inherit" size="large">
								<Badge badgeContent={pendingApprovals} color="secondary" classes={{
									colorSecondary: ColorSecondaryBadge,
									badge: (pendingApprovals === 0 ? HideBadge : ModifiedBadge)
								}}>
									<ApprovalIcon />
								</Badge>
							</IconButtonRoot>
							&nbsp;<small><FormattedMessage id="solicitation.approval" /></small>
						</CenteredLinkMenuItemDiv>
					</NavLink>
				</MenuItem>
				<MenuItem onClick={() => this.handleMobileMenuClose()}>
					<NavLink to="/cloak/settings">
						<CenteredLinkMenuItemDiv>
							<IconButtonRoot color="inherit" size="large">
								<SettingsIcon />
							</IconButtonRoot>
							&nbsp;<small><FormattedMessage id="cloak.settings" /></small>
						</CenteredLinkMenuItemDiv>
					</NavLink>
				</MenuItem>
				<MenuItem onClick={() => this.onLogout()}>
					<CenteredLinkMenuItemDiv>
						<IconButtonRoot color="inherit" size="large">
							<LogoutIcon />
						</IconButtonRoot>
						&nbsp;<small><FormattedMessage id="logout" /></small>
					</CenteredLinkMenuItemDiv>
				</MenuItem>
			</Menu>
		);

		return (
			<div id="menu-bar" className="clk-primary-menu-bar">
				{
					token &&
					<Processing show={authInProgress} processing={authInProgress} style={modalStyle} message='login.loggingOut' />
				}
				<CloakKey />
				<ChangePwd />
				<RevokeCert />
				{!token ?
					(
						<div className="pseudo-login-div">
							<a href="https://www.cloakapps.com">
								<img src="/cloak/public/img/Application_Icon_cloak_32.png" title="cloak site" alt="cloak site" />
							</a>
						</div>
					) : (
						<div className="pseudo-div">
							<a href="https://www.cloakapps.com">
								<img src="/cloak/public/img/Application_Icon_cloak_32.png" title="cloak site" alt="cloak site" />
							</a>
						</div>
					)
				}

				{!token ?
					(
						<div className="clk-primary-menu-bar-login-div" >
							<NavLink to="/cloak/qr" className="clk-primary-menu-bar-link">
								<div id="cloakQR" onClick={() => this.selected("cloakQR")} style={this.state.cloakQR ? { color: '#ffffff', textAlign: 'center' } : { textAlign: 'center' }}>
									<FormattedMessage id="cloak.cloakQR" />&nbsp;&nbsp;&nbsp;
								</div>
							</NavLink>
							<div className="clk-primary-menu-bar-link-separator" />
							<NavLink to="/cloak/signup" className="clk-primary-menu-bar-link">
								<div id="signUp" onClick={() => this.selected("signUp")} style={this.state.signUp ? { color: '#ffffff', textAlign: 'center' } : { textAlign: 'center' }}>
									<FormattedMessage id="signUp.title" />
								</div>
							</NavLink>
							<div className="clk-primary-menu-bar-link-separator" />
							<NavLink to="/cloak/login" className="clk-primary-menu-bar-link" >
								<div id="login" onClick={() => this.selected("login")} style={this.state.login ? { color: '#ffffff', textAlign: 'center' } : { textAlign: 'center' }}>
									<FormattedMessage id="login.title" />
								</div>
							</NavLink>
						</div>
					) : (
						<div className="clk-primary-menu-bar-link-div" >
							<div className="clk-primary-menu-bar-link-user" >
								<Tooltip title={<FormattedMessage id="cloak.cloakQR" />}>
									<IconButton color="inherit" size="large">
										<NavLink to="/cloak/qr" style={{ color: '#fff' }}>
											<QRIcon />
										</NavLink>
									</IconButton>
								</Tooltip>
							</div>
							<div className="clk-primary-menu-bar-link-user" >
								<Tooltip title={<FormattedMessage id="cloak.cloak" />}>
									<IconButton color="inherit" size="large">
										<NavLink to="/cloak/cloak" style={{ color: '#fff' }}>
											<FileLockIcon />
										</NavLink>
									</IconButton>
								</Tooltip>
							</div>
							<div className="clk-primary-menu-bar-link-user" >
								<Tooltip title={<FormattedMessage id="cloak.uncloak" />} >
									<IconButton color="inherit" size="large">
										<NavLink to="/cloak/uncloak" style={{ color: '#fff' }}>
											<FileUnlockIcon />
										</NavLink>
									</IconButton>
								</Tooltip>
							</div>
							<div className="clk-primary-menu-bar-link-badged-user" >
								<Tooltip title={<FormattedMessage id="solicitation.request" />}>
									<IconButton color="inherit" size="large">
										<NavLink to="/cloak/requests" style={{ color: '#fff' }}>
											<Badge badgeContent={pendingRequests} color="secondary" classes={{
												colorSecondary: ColorSecondaryBadge,
												badge: (pendingRequests === 0 ? HideBadge : ShowBadge)
											}}>
												<RequestIcon />
											</Badge>
										</NavLink>
									</IconButton>
								</Tooltip>
							</div>
							<div className="clk-primary-menu-bar-link-badged-user" >
								<Tooltip title={<FormattedMessage id="solicitation.approval" />} >
									<IconButton color="inherit" size="large">
										<NavLink to="/cloak/approvals" style={{ color: '#fff' }}>
											<Badge badgeContent={pendingApprovals} color="secondary" classes={{
												colorSecondary: ColorSecondaryBadge,
												badge: (pendingApprovals === 0 ? HideBadge : ShowBadge)
											}}>
												<ApprovalIcon />
											</Badge>
										</NavLink>
									</IconButton>
								</Tooltip>
							</div>
							<div className="clk-primary-menu-bar-link-user" >
								<Tooltip title={<FormattedMessage id="cloak.settings" />} >
									<IconButton color="inherit" size="large">
										<NavLink to="/cloak/settings" style={{ color: '#fff' }}>
											<SettingsIcon />
										</NavLink>
									</IconButton>
								</Tooltip>
							</div>
							<div className="clk-primary-menu-bar-link-user" >
								<Tooltip title={<FormattedMessage id="logout" />}>
									<IconButton color="inherit" onClick={() => this.onLogout()} size="large">
										<LogoutIcon />
									</IconButton>
								</Tooltip>
							</div>
							<div className="clk-primary-menu-bar-link-mobile">
								<IconButton
									aria-haspopup="true"
									onClick={(e) => this.handleMobileMenuOpen(e)}
									color="inherit"
									size="large">
									<MoreIcon />
								</IconButton>
							</div>
						</div>
					)
				}

				{renderMobileMenu}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		token: state.auth.token,
		pendingApprovals: state.lic.pendingApprovals,
		pendingRequests: state.lic.pendingRequests,
		authInProgress: state.auth.authInProgress
	}
};

export default connect(mapStateToProps)(withNavigation(PrimaryMenuBar));
